import { makeStyles } from '@rbx/ui';

// Hard-coded numbers adjusted away from the spec
const h2Margin = 64;
const h3Margin = 48;
const h4Margin = 32;

const useHeadingGroupStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    // fontSize: customMarkdownFontSize,
    '& h2[id]': {
      marginTop: `${h2Margin}px`,
    },
    '& h3[id]': {
      marginTop: `${h3Margin}px`,
    },
    '& h4[id]': {
      marginTop: `${h4Margin}px`,
    },
  },

  articleHeader: {
    '& > h2[id]:first-child': {
      marginTop: 0,
    },
    '& > h3[id]:first-child': {
      marginTop: 0,
    },
    '& > h4[id]:first-child': {
      marginTop: 0,
    },
  },
}));

export default useHeadingGroupStyles;
